module.exports = __webpack_public_path__ + "img/w15-b2.15022477.jpg";